import { downloadCSV } from '@helpers/downloadCSV';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import type { TransactionResponseDto } from 'app/API';

const headers = ['ID', 'Title', 'Charge ID', 'Amount', 'Type', 'Receipt URL', 'Created'];

type TTransactionCsvData = Pick<
  TransactionResponseDto,
  'id' | 'title' | 'stripeChargeId' | 'amount' | 'stripeReceiptUrl' | 'createdAt'
> & {
  code: Pick<TransactionResponseDto['code'], 'name'>;
};

export const downloadBillingTransactionsCsv = (transactions: TTransactionCsvData[]) => {
  const array = transactions.map((data) => {
    return {
      id: data.id,
      title: data.title,
      chargeId: data.stripeChargeId ?? data.id,
      amount: `$${(data.amount / 100).toFixed(2)}`,
      type: data.code.name,
      receiptUrl: data.stripeReceiptUrl ?? '',
      created: getAmericanTime(data.createdAt),
    };
  });

  return downloadCSV(array, headers);
};
